import { TFunction } from 'react-i18next'
import { DesiredWeeklySchedule_desiredWeeklySchedule } from '../../../gql/desiredWeeklySchedule/__generated__/DesiredWeeklySchedule'
import { i18nKeyPrefix } from '../i18n'
import { IParams, IValidation } from './types'

const PRE = `${i18nKeyPrefix}-VALIDATIONS`

export function buildInitialParams(schedule: DesiredWeeklySchedule_desiredWeeklySchedule | null) {
  if (!schedule) {
    return {
      days: {
        friday: false,
        monday: false,
        thursday: false,
        tuesday: false,
        wednesday: false,
      },
      dropoffAt: null,
      pickupAt: null,
    }
  }

  return {
    days: {
      friday: schedule.friday,
      monday: schedule.monday,
      thursday: schedule.thursday,
      tuesday: schedule.tuesday,
      wednesday: schedule.wednesday,
    },
    dropoffAt: schedule.dropoffAt,
    pickupAt: schedule.pickupAt,
  }
}

export function validateWithTranslation(params: IParams, t: TFunction) {
  const hints: IValidation = {}
  const { days, dropoffAt, pickupAt } = params

  if (Object.values(days).every(day => !day)) {
    hints.days = t(`${PRE}-DAYS`)
  }

  if (!dropoffAt) {
    hints.dropoffAt = t(`${PRE}-DROP-OFF`)
  }

  if (!pickupAt) {
    hints.pickupAt = t(`${PRE}-PICK-UP`)
  }

  if (dropoffAt && pickupAt && pickupAt <= dropoffAt) {
    hints.times = t(`${PRE}-TIMES`)
  }

  return Object.keys(hints).length ? hints : null
}
